import { render, staticRenderFns } from "./LeftoversInfoDialog.vue?vue&type=template&id=cd19fae6&scoped=true&"
import script from "./LeftoversInfoDialog.vue?vue&type=script&lang=js&"
export * from "./LeftoversInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./LeftoversInfoDialog.vue?vue&type=style&index=0&id=cd19fae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd19fae6",
  null
  
)

export default component.exports